import { CloseOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Form, Modal, notification, Typography } from 'antd';
import React, { useCallback, useState } from 'react';
import { reviewHolisticProposalMutation } from '../constants';

const { Title, Paragraph } = Typography;

const RejectHolisticProjectProposalBtn = ({ report, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [showingModal, setShowingModal] = useState(null);
  const [reviewHolisticProjectRequestReport] = useMutation(
    reviewHolisticProposalMutation,
  );

  const handleFinish = useCallback(async () => {
    setLoading(true);
    try {
      await reviewHolisticProjectRequestReport({
        variables: {
          reportId: report._id,
          status: 'REJECTED',
        },
      });
      notification.success({
        message: 'Saved',
        description: 'Proposal Rejected',
      });
      setShowingModal(null);
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      console.log(err);
      notification.error({
        message: 'Error',
        description: 'We apologize.  An error occurred.',
      });
    }
    setLoading(false);
  }, [reviewHolisticProjectRequestReport, report, onSuccess]);

  return (
    <>
      <Button
        loading={loading}
        icon={<CloseOutlined />}
        onClick={() => setShowingModal(true)}
      >
        Reject Proposal
      </Button>

      <Modal
        header={null}
        footer={null}
        visible={showingModal}
        closable={!loading}
        destroyOnClose={true}
        maskClosable={!loading}
        onCancel={() => {
          setShowingModal(false);
        }}
        styles={{ body: { paddingTop: 48 } }}
      >
        <Title level={3} style={{ textAlign: 'center', marginBottom: 32 }}>
          Reject Proposal
        </Title>
        <Form onFinish={handleFinish} layout="vertical">
          <Form.Item>
            <Paragraph style={{ textAlign: 'center' }}>
              {`Are you sure you want to reject this holistic project proposal?  The submitter will be informed that his proposal has been rejected and this proposal will be hidden from view.`}
            </Paragraph>
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <div
              style={{
                marginRight: -8,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Button
                onClick={() => setShowingModal(null)}
                htmlType="button"
                disabled={loading}
                style={{ marginLeft: 8, marginRight: 8, marginBottom: 8 }}
              >
                Cancel
              </Button>
              <Button
                htmlType="submit"
                type="primary"
                loading={loading}
                style={{ marginLeft: 8, marginRight: 8, marginBottom: 8 }}
              >
                Reject Proposal
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>

      <style jsx>{``}</style>
      <style jsx global>{``}</style>
    </>
  );
};

export default RejectHolisticProjectProposalBtn;
